import { Component, contentChild, input, model, TemplateRef } from '@angular/core';
import { NgTemplateOutlet } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

/** Collapsible white card section (design: "Avvik 1 ⌄", "Opplastede dokumenter 2 ⌄"). */
@Component({
  selector: 'mbm-accordion',
  imports: [TranslateModule, NgTemplateOutlet],
  templateUrl: './mbm-accordion.component.html',
  styleUrl: './mbm-accordion.component.scss',
})
export class MbmAccordionComponent {
  readonly titleKey = input<string>('');
  readonly title = input<string | undefined>(undefined);
  readonly badgeCount = input<number | undefined>(undefined);
  readonly expanded = model<boolean>(false);
  readonly disabled = input<boolean>(false);

  protected readonly contentTemplate = contentChild(TemplateRef);

  protected toggle(): void {
    if (this.disabled()) return;
    this.expanded.set(!this.expanded());
  }
}
